// extracted by mini-css-extract-plugin
module.exports = {"mainModal":"Modal_mainModal__2XsaF","p_moduleBody":"Modal_p_moduleBody__34Kml","Modal":"Modal_Modal__8WBTs"};